"use client";
import type { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { useParams, useRouter } from "next/navigation";

import type { ProductType } from "../api_client/types.gen";
import { matchProductType } from "../utils/productUtils";

type Views = "edit" | "price";

const getViewRoute = (productType: ProductType, view: Views) =>
  matchProductType(productType, {
    travel: `travel/${view}`,
    householder: `householder/${view}`,
    car: `car/${view}`,
    income: `income/${view}`,
    baby: `baby/${view}`,
    sport: `sport/${view}`,
    child: `child/${view}`,
    cat: `cat/${view}`,
    dog: `dog/${view}`,
    van: `van/${view}`,
    "": undefined,
  });

const getGoToView =
  (router: AppRouterInstance, language: string, view: Views) =>
  (productType?: ProductType, productId?: string | null) => {
    if (!productType || !productId) {
      router.push("/");
      return;
    }
    const route = getViewRoute(productType, view);
    if (!route) {
      router.push("/");
      return;
    }
    router.push(`/${language}/${route}?id=${productId}`);
  };

export const useProductNavigationHandlers = () => {
  const { language } = useParams<{ language: string }>();
  const router = useRouter();

  const goToEditProduct = getGoToView(router, language, "edit");
  const goToPricePage = getGoToView(router, language, "price");

  return {
    goToEditProduct,
    goToPricePage,
  };
};
